export default "__VITE_ASSET__Dga6dx2___"